import { X, Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { useSite } from "./SiteContext";
import { useCatalogue, displayName } from "./useCatalogue";

/* Side drawer quick view */
export default function QuickView({ product, onClose }) {
  const { add } = useSite();
  const { categories } = useCatalogue();
  if (!product) return null;
  const cat = categories.find((c) => c.slug === product.category);
  return (
    <div className="qv-overlay" onClick={onClose} data-testid="quickview-drawer">
      <aside className="qv" onClick={(e) => e.stopPropagation()}>
        <button className="qv-close" onClick={onClose} aria-label="Close quick view" data-testid="quickview-close"><X size={20} /></button>
        <div className="qv-img"><img src={product.image} alt={product.name} /></div>
        <p className="qv-cat">{cat ? displayName(cat.name) : ""}</p>
        <h3>{displayName(product.name)}</h3>
        <p className="qv-code">{product.code}</p>
        <p className="qv-desc">{product.description}</p>
        <table className="spec-table">
          <tbody>
            <tr><td>Product code</td><td>{product.code}</td></tr>
            {product.configuration && <tr><td>Configuration</td><td>{product.configuration}</td></tr>}
            {product.capacity && <tr><td>Capacity</td><td>{product.capacity}</td></tr>}
            <tr><td>Material</td><td>{product.material}</td></tr>
            <tr><td>Finish</td><td>{product.finish}</td></tr>
            <tr><td>Dimensions</td><td>Shared with quotation</td></tr>
          </tbody>
        </table>
        <div className="qv-actions">
          <button className="btn btn-accent" onClick={() => { add(product); }} data-testid="quickview-add"><Plus size={14} /> Add to enquiry</button>
          <Link className="btn btn-ghost" to={`/product/${product.code}`} data-testid="quickview-full">Full details</Link>
        </div>
      </aside>
    </div>
  );
}
